<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header"><h3>{{$t('pages.ResetPassword')}}</h3></div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error">
                            {{$t(error)}}
                        </div>
                        <form @submit="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="resetPassword"/>
                            <button type="submit" :class="(disabled ? 'disabled': '') +' btn btn-primary'"
                                    :disabled="disabled">{{ $t('button.Send') }}
                            </button>
                        </form>
                        <vue-recaptcha :sitekey="siteKey"
                                       @expired="onExpired"
                                       @verify="onVerify"
                                       ref="recaptcha"
                                       size="invisible">

                        </vue-recaptcha>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import isLength from 'validator/lib/isLength';
  import { mapActions } from 'vuex';
  import { ERROR_MESSAGES, SITE_KEY_RECAPTCHA } from '../../constants';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'ResetPassword',
    components: { VueRecaptcha },
    data() {
      return {
        siteKey: SITE_KEY_RECAPTCHA,
        disabled: false,
        error: '',
        form: {},
        model: {
          password: '',
          password_confirmation: ''
        },
        fields: [
          {
            key: 'password',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Password'),
              inputType: 'password'
            },
            required: true,
            validators: {
              validPassword: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'password_confirmation',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.ConfirmPassword'),
              inputType: 'password'
            },
            required: true,
            validators: {
              validPassword: {
                expression: (field, model, next) => {
                  next(model[field.key] === this.model.password);
                },
                message: this.$tc('validation.confirmed', 3)
              }
            }
          }
        ]
      };
    },
    methods: {
      ...mapActions(['resetPassword']),
      submit(e) {
        e.preventDefault();
        this.error = null;
        this.$refs.resetPassword.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;

            this.$refs.recaptcha.execute();
          });
      },
      onExpired() {
        this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
      },
      onVerify(recaptcha) {
        return this.resetPassword({
          ...this.model,
          recaptcha,
          token: this.$route.query.token
        })
          .then(() => {
            this.$router.push('/login');
          })
          .catch((e) => {
            this.$refs.recaptcha.reset();
            this.disabled = false;
            if (e.response.data && e.response.data.message) {
              this.error = 'errorMessages.' + e.response.data.message;
            } else {
              this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
            }
          });
      }
    }
  };
</script>

<style scoped>

</style>
